import React from 'react';
import ReactModal from 'react-modal';
import moment from 'moment';
import PropTypes from 'prop-types';
import Swal from 'sweetalert2';
import { createFetch } from '../../utils';


class ModalSearchRow extends React.Component {
    constructor() {
        super();
        this.state = {
            data: [],
            keyword: '',
            loading: false,
        };
    }

    componentWillMount() {

    }

    componentWillReceiveProps(nextProps) {
        if (this.props.objectName !== nextProps.objectName) {
            this.setState({ data: [] });
        }
        return true;
    }

    async searchData() {
        if (this.state.loading) return;
        const { objectName, accessToken } = this.props;
        try {
            this.setState({ loading: true });
            const {
                records, status, validation, message,
            } = await createFetch({
                path: `guest/find-reference/${objectName}?query=${this.state.keyword}`,
                method: 'get',
                accessToken,
            });
            if (status === 200) {
                this.setState({ data: records, loading: false });
                return;
            }
            const error = new Error();
            error.validation = validation;
            error.message = message;
            throw error;
        } catch (error) {
            this.setState({ loading: false });
            Swal.fire({
                type: 'error',
                title: 'Failed to updated',
                text: error.message,
                backdrop: true,
            });
        }
    }

    render() {
        const {
            data, keyword, loading,
        } = this.state;
        return (
            <ReactModal
                isOpen={this.props.visible}
                onRequestClose={this.props.onClose}
                className="search-action"
                ariaHideApp={false}
            >
                <h2>{this.props.objectName}</h2>
                <p className="text-center">
                    {loading ? <i className="fa fa-circle-notch fa-spin fa-4x loading" /> : null}
                </p>
                <div className="flex">
                    <input value={keyword} type="text" className="form-control" placeholder="keyword" onChange={e => this.setState({ keyword: e.target.value })} />
                    <button className="btn btn-sm btn-success" onClick={() => this.searchData()}>
                        <i className="fa fa-search" />
                    </button>
                </div>
                <table className="table">
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Name</th>
                            <th>Last Modified Date</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map(o => (
                            <tr>
                                <td>{o.Id}</td>
                                <td>{o.Name}</td>
                                <td>{moment(o.LastModifiedDate).format('DD-MMM-YYYY hh:mm a')}</td>
                                <td>
                                    <button
                                        className="btn-sm btn-info"
                                        onClick={() => {
                                            this.props.onPick(o);
                                        }}
                                    >
                                        Pick
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </ReactModal>
        );
    }
}

ModalSearchRow.propTypes = {
    objectName: PropTypes.string.isRequired,
    onPick: PropTypes.func.isRequired,
    accessToken: PropTypes.string.isRequired,
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
};


export default ModalSearchRow;
